import { useCurrentNetwork } from '../../../hooks';
import facebookFilterStore from '../facebook/stores/filterStore';
import googleFilterStore from '../google/stores/googleFiltersStore';
import type { FilterStoreType } from '../types';
import type { Network } from '../../../types/shared';

const useFilterStore = (): FilterStoreType => {
  const network = useCurrentNetwork();

  const filterStores: Record<Network, FilterStoreType> = {
    facebook: facebookFilterStore,
    google: googleFilterStore,
  };

  return filterStores[network];
};

export default useFilterStore;
